import React from 'react';

function Filter({ width }) {
  return (
    <svg width={width || '18'} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip-filter-003477nfy)">
        <path
          d="M16.579 0.267578H1.42101C1.16975 0.267578 0.92878 0.367391 0.751113 0.545058C0.573446 0.722725 0.473633 0.963694 0.473633 1.21495V3.66866C0.473633 4.16413 0.675424 4.65109 1.02595 5.00162L6.15789 10.1335V17.3203C6.15807 17.4818 6.19945 17.6404 6.27811 17.7814C6.35676 17.9223 6.47009 18.0409 6.60736 18.1258C6.74463 18.2107 6.9013 18.2591 7.06254 18.2666C7.22378 18.274 7.38424 18.2402 7.52874 18.1682L11.3182 16.2735C11.6394 16.1124 11.8421 15.7846 11.8421 15.4256V10.1335L16.9741 5.00162C17.3246 4.65109 17.5264 4.16413 17.5264 3.66866V1.21495C17.5264 0.963694 17.4266 0.722725 17.2489 0.545058C17.0713 0.367391 16.8303 0.267578 16.579 0.267578ZM10.225 9.07154C10.1368 9.15937 10.0669 9.26376 10.0193 9.37871C9.97164 9.49367 9.94721 9.6169 9.94739 9.74134V14.8401L8.05264 15.7875V9.74134C8.05282 9.6169 8.02839 9.49367 7.98075 9.37871C7.93311 9.26376 7.8632 9.15937 7.77506 9.07154L2.36838 3.66866V2.16233H15.6326L15.6345 3.66203L10.225 9.07154Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip-filter-003477nfy">
          <rect width="18" height="18" fill="white" transform="translate(0 0.267578)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Filter;
